export const useHashRoute = (route: string) => `#${route}`;
